import { IVendorLocationDto } from "api/contacts-api-dto-interfaces";
import { sortBy } from "lodash-es";

export const sortVendorLocations = (locations: IVendorLocationDto[]) => {
  if (!locations || locations.length === 0) return;
  return sortBy(locations, function (loc) {
    return loc.nickname.toLowerCase();
  });
};
